var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.child.tooltipText)?_c('TooltipInfoDot',{attrs:{"label":_vm.child.tooltipLabel,"text":_vm.child.tooltipText}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }